export enum IntegrationsApiTag {
  conversationMessages = "conversationMessages",
  whatsappMessageMedia = "whatsappMessageMedia",
  whatsappTemplate = "whatsappTemplate",
  whatsappProfile = "whatsappProfile",
  crmConfig = "crmConfig",
  workflowLogs = "workflowLogs",
  shopifyAccount = "shopifyAccount",
  instagramMessage = "instagramMessage",
  calendlyConnection = "calendlyConnection",
  squareupConnection = "squareupConnection",
  agentConfig = "agentConfig",
  calcomConnection = "calcomConnection",
}
